import { Box, SvgIcon } from '@mui/material';

interface HeaderIconProps {
  isSelected?: boolean;
  iconComponent: React.FC<any>;
}

const HeaderIcon: React.FC<HeaderIconProps> = (props) => {
  const { isSelected, iconComponent } = props;
  return (
    <Box
      className={isSelected ? 'selected' : ''}
      sx={{
        transform: 'scale(1.2)',
        '&:hover, &.selected': {
          filter: 'none',
          transform: 'scale(1.4)',
        },
        filter: 'grayscale(100%)',
        transition: 'all 0.2s ease-in-out',
        alignItems: 'center',
        alignContent: 'center',
        display: 'flex',
        justifyContent: 'center',
        m: 0,
        mb: 1,
        height: 24,
      }}
    >
      {' '}
      <SvgIcon
        sx={{ fontSize: { sm: 25, md: 35 } }}
        component={iconComponent}
        inheritViewBox={true}
      />
    </Box>
  );
};

export default HeaderIcon;
